import { PaginatedGridLayout } from '@dec/shared';
import { type ColDef, type GridReadyEvent } from 'ag-grid-community';
import { OnlyGrid, type RowSelectionValue } from 'app/components/grid/gridApplication';
import type Paginated from 'app/core/paginable';
import { label } from 'app/modules/translation';
import { t } from 'i18next';

interface PaginableProps {
  pagedTop?: boolean;
  hideHeaders?: boolean;
  columnDefs: Array<ColDef>;
  defaultColDef?: ColDef;
  setPage: (page: number) => void;
  page: number;
  data: Paginated<any>;
  rowSelection?: 'single' | 'multiple';
  rowSelected?: (event: RowSelectionValue) => void;
  onGridReady?: (params: GridReadyEvent) => void;
  exportable?: boolean;
  exportFn?: () => Promise<void>;
}

export const PaginableGrid = ({
  hideHeaders,
  columnDefs,
  defaultColDef,
  data,
  setPage,
  page,
  pagedTop,
  rowSelection,
  rowSelected,
  onGridReady,
  exportable,
  exportFn
}: PaginableProps) => {
  return (
    <PaginatedGridLayout
      grid={
        <OnlyGrid
          onGridReady={onGridReady}
          rowSelected={rowSelected}
          rowSelection={rowSelection}
          hideHeaders={hideHeaders}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          data={data.data}
        />
      }
      data={data}
      page={page}
      onPage={setPage}
      pagedTop={pagedTop}
      entriesLabel={label('page-entries')}
      excelLabel={t('common.label.excel')}
      exportable={exportable}
      exportFn={exportFn}
    />
  );
};

export const OverlaNoRowsTemplate = () => {
  return (
    <span style={{ padding: '10px', border: '2px solid #444', background: '#e9ecef' }}>
      {label('noFound')}
    </span>
  );
};
